import { useRouter } from 'next/router';
import * as React from 'react';

import { Loading } from '@/imports/ui/chakra/components/Loading';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

// the canonical url is "/messages/:cid" but this causes some issues, so i've
// updated this route to redirect to "/messages?cid={cid}" so that it is easier
// to manage the page state

const Page: React.FC = () => {
  const router = useRouter();

  const cid = router.query.cid ? router.query.cid.toString() : undefined;

  React.useEffect(() => {
    if (cid) {
      router.replace(`/messages?cid=${cid}`);
    } else {
      router.replace('/messages');
    }
  });

  return <Loading />;
};

export default restrictedRoute(Page, {
  requiresEvery: [RouteRestrictions.AUTHENTICATION],
  requiresSome: [
    RouteRestrictions.ORGANIZATION_DASHBOARD_ACCESS,
    RouteRestrictions.DM_PAGE_ACCESS,
  ],
});
